import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Background from '../assets/community/hero.png';

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#000",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        backgroundImage: 'url(' + Background + ')',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '100%',
        minHeight: '282px',
        display: 'flex',
        backgroundSize: 'cover',
        backgroundPosition: 'center',

        [theme.breakpoints.up('sm')]: {
            minHeight: '386px',
        },

        [theme.breakpoints.up('md')]: {
            minHeight: '570px',
        }
    },
    content: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        color: '#FFF',
    },
});

class CommunityImagePanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            totalTrees: 0
        };
    }

    render() {
        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.panel}>
                <div className={classes.content}>
                </div>
            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(CommunityImagePanel)